import React, { PropsWithChildren } from 'react';
import 'twin.macro';
import tw, { TwStyle } from 'twin.macro';

export type LegendVariant = 'quiet' | 'moderate' | 'intense';
interface LegendProps {
  style?: TwStyle;
  variant?: LegendVariant;
  required?: boolean;
}

export function Legend(props: PropsWithChildren<LegendProps>) {
  const { children, style, variant, required } = props;
  return (
    <legend
      css={[
        tw`text-sm mb-3`,
        style,
        variant === 'moderate' && tw`text-neutral-moderate font-bold`,
        variant === 'quiet' && tw`text-neutral-quiet`,
        variant === 'intense' && tw`text-neutral-intense`,
      ]}
    >
      {children}
      {required && <span tw="ml-1 text-brand-intense">*</span>}
    </legend>
  );
}
